export const realTimeUrl = 'https://www.gps.bg/fm/site/index.jsp';
